{
  "de": {
    "building": {
      "attributes": {
        "description": "Beschreibung",
        "elevators": "Anzahl Aufzüge",
        "end_date": "Enddatum",
        "floors": "Anzahl Etagen",
        "internal_note": "Interne Notiz zum Gebäude",
        "name": "Name",
        "start_date": "Startdatum",
        "surface_shared": "Gemeinschaftsfläche"
      },
      "labels": {
        "building": "Kein Gebäude | Ein Gebäude | {count} Gebäude"
      },
      "toasts": {
        "create": "Gebäude wurde erstellt",
        "delete": "Gebäude wurde gelöscht",
        "update": "Gebäude wurde aktualisiert"
      },
      "validation": {
        "needName": "Titel ist erforderlich",
        "needNumber": "Muss eine Zahl sein (z. B. 85)"
      }
    }
  }
}
